export function isPortalOlderThanDays(portal, days) {
  const portalCreatedDate = new Date(portal.created_at);
  const comparisonDate = new Date();
  comparisonDate.setDate(comparisonDate.getDate() - days);
  return portalCreatedDate <= comparisonDate;
}